/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetRenewalEligibleResponse } from '../models/ApiResponseGetRenewalEligibleResponse';
import type { GetRenewalEligibleResponse } from '../models/GetRenewalEligibleResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LicenseRenewalControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns string OK
   * @throws ApiError
   */
  public getCacheKey1(): CancelablePromise<Array<string>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/license-renewal/cache',
    });
  }
  /**
   * @returns GetRenewalEligibleResponse OK
   * @throws ApiError
   */
  public getCacheKey({
    ci,
    renewalType,
  }: {
    ci: string,
    renewalType: 'CLASS1_RENEWAL' | 'CLASS2_RENEWAL' | 'OVER_70YEARS_RENEWAL' | 'ACCIDENT_FREE_OVER_7YEARS' | 'ACCIDENT_FREE_OVER_7YEARS_RENEWAL' | 'NOT_SUBJECT' | 'FAIL_CUSTOMER_INFO' | 'FAIL_SYSTEM_ERROR' | 'FAIL_POLICE_CASE' | 'FAIL_OVER_75YEARS',
  }): CancelablePromise<GetRenewalEligibleResponse> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/public-service/license-renewal/cache',
      query: {
        'ci': ci,
        'renewalType': renewalType,
      },
    });
  }
  /**
   * @returns ApiResponseGetRenewalEligibleResponse OK
   * @throws ApiError
   */
  public getLicenseRenewal({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<ApiResponseGetRenewalEligibleResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/public-service/license-renewal',
      headers: {
        'Authorization': authorization,
      },
    });
  }
}
